import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { mapBusinessPriorityFromApi, TBusinessPriorityApiPayload } from '../lib'
import { IBusinessPriority } from '../model/types'

import { IBusinessPriorityApi } from './types'

export const applyBusinessPrioritiesChanges = async (
  payload: TBusinessPriorityApiPayload
): Promise<IBusinessPriority> => {
  const response = await callProcedure<IProcedureResponse<IBusinessPriorityApi[]>>({
    url: '/webservice/621/sp/v4/spJBPBusinessPrioritiesApplyChanges/call',
    method: 'POST',
    data: {
      'p.JsonData': JSON.stringify(payload),
    },
  })

  if ('error' in response) {
    throw response.error
  }

  const apiData = response.data.Data ?? []

  const mappedUpdatedRecords = apiData.map(mapBusinessPriorityFromApi)
  const [updatedRecord] = mappedUpdatedRecords

  return updatedRecord
}
